import { DataTypes, DataVariants } from "../../../data/DataManager";
import { InputTypes } from "../../../form/FormManager";
import { FieldSchema } from "../../../Schema";
import { Reason } from "../external-sources/Reasons";
import { SchemaContext } from "../../common";

export const createEditReason = (context: SchemaContext): FieldSchema => ({
  name: "editReason",
  display: { displayed: false },
  dataTransform: {
    // Stored and sent as the text, held here as the option it names — the same asymmetry
    // siteName has. Without this an inbound reason stays a string, matches none of the
    // options, and the enum check reduces it to EMPTY_VALUE, taking the record of why a
    // change was made with it.
    fromGraphql: {
      getter: ({ editReason }) => context.reasons.find(
        (option) => option.value?.configText === editReason
      )?.value,
    },
    toGraphql: {
      getter: ({ editReason }) => (editReason as Reason)?.configText,
    },
    toDb: {
      getter: ({ editReason }) => (editReason as Reason)?.configText,
    },
  },
  data: {
    type: DataTypes.OBJECT,
    variant: DataVariants.ENUM,
    options: context.reasons,
  },
  validation: { required: true },
  form: { label: "Reason", type: InputTypes.SELECT },
});
